/* eslint-disable react-hooks/exhaustive-deps */
import React, { FunctionComponent } from 'react';
import { ISettings } from '../../../../../app/resource/settings/settings.types';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { SlackIntegration } from './IntegrationsTab/SlackIntegration';
import { WrikeIntegration } from './IntegrationsTab/WrikeIntegration';

export const Integrations: FunctionComponent<{ settings: ISettings }> = ({ settings }) => {
  return (
    <div className="col px-0">
      <div className="field-container px-2 mb-5">
        <div className="panel theme-gradient-2 py-1 px-2 flex aic my-3">
          <h2 className="f-14 white bold">INTEGRATIONS</h2>
        </div>
        <SlackIntegration settings={settings} />
        <WrikeIntegration settings={settings} />
      </div>
    </div>
  );
};
